"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _animations = require("@staccx/animations");

var _themeContants = require("../../../constants/themeContants");

var _theming = require("../../../theming");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var ProgressBar = function ProgressBar(_ref) {
  var progress = _ref.progress,
      className = _ref.className,
      warningThreshold = _ref.warningThreshold,
      otherProps = _objectWithoutProperties(_ref, ["progress", "className", "warningThreshold"]);

  if (progress > 1) {
    console.warn("Progress is above max (1). Please enter correct value");
    progress *= 0.01;
  }

  return _react["default"].createElement(Bg, _extends({
    className: className
  }, otherProps), _react["default"].createElement(Bar, {
    width: progress,
    warningThreshold: warningThreshold
  }, _react["default"].createElement(Progress, null, progress >= 1 ? "100" : Math.round(progress * 100), "%")));
};

var themeProps = {
  background: {
    name: "progress_bar",
    description: "Progress bar background style",
    type: _themeContants.themePropTypes.style
  },
  bar: {
    name: "progress_bar_bar",
    description: "Progress bar bar style",
    type: _themeContants.themePropTypes.style
  },
  progress: {
    name: "progress_bar_progress",
    description: "Progress bar progress style",
    type: _themeContants.themePropTypes.style
  }
};

var Bg = _styledComponents["default"].div.withConfig({
  displayName: "ProgressBar__Bg",
  componentId: "sc-1g3dqu-0"
})(["background:", ";display:block;height:", ";min-width:200px;border-radius:", ";position:relative;overflow:hidden;border:3px solid ", ";-webkit-mask-image:-webkit-radial-gradient( white,black );", ";"], _theming.color.subtleHover, _theming.spacing.medium, _theming.spacing.small, _theming.color.subtleHover, (0, _theming.applyVariants)(themeProps.background.name));

var Bar = _styledComponents["default"].div.withConfig({
  displayName: "ProgressBar__Bar",
  componentId: "sc-1g3dqu-1"
})(["position:absolute;background-color:", ";left:0;height:100%;width:", "%;border-radius:0 ", " ", " 0;transform:scaleX(0);animation:", " 0.4s cubic-bezier(0.175,0.885,0.32,1.275) 0.3s 1 forwards;transform-origin:left center;", ";"], function (p) {
  return p.width >= p.warningThreshold ? _theming.color.warning : _theming.color.primary;
}, function (p) {
  return p.width > 1 ? "100" : p.width * 100;
}, _theming.spacing.small, _theming.spacing.small, _animations.ScaleInX, (0, _theming.applyVariants)(themeProps.bar.name));

var Progress = _styledComponents["default"].span.withConfig({
  displayName: "ProgressBar__Progress",
  componentId: "sc-1g3dqu-2"
})(["position:absolute;right:", ";line-height:18px;font-size:", ";color:", ";", ";"], _theming.spacing.small, _theming.font.tiny, _theming.color.white, (0, _theming.applyVariants)(themeProps.progress.name));

ProgressBar.defaultProps = {
  className: "",
  warningThreshold: 0.9
};
ProgressBar.propTypes = {
  /**
   * Progress normalized (0-1)
   */
  progress: _propTypes["default"].number.isRequired,
  warningThreshold: _propTypes["default"].number,
  className: _propTypes["default"].string
};
ProgressBar.themeProps = themeProps;
var _default = ProgressBar;
exports["default"] = _default;